import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ach-payment-reconcilation',
  templateUrl: './ach-payment-reconcilation.component.html',
  styleUrls: ['./ach-payment-reconcilation.component.scss']
})
export class AchPaymentReconcilationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
